import { registerPlugin } from '@capacitor/core';
const OtaUpdate = registerPlugin('OtaUpdate', {
  web: () => import('./web').then((m) => new m.OtaUpdateWeb()),
});
export * from './definitions';
export { OtaUpdate };
